/* LogsViewComponent.js */

"use strict";

const BaseLogsViewComponent = require("../../../../../../lib/logs/BaseLogsViewComponent");
const Renderer = require("./LogsViewRenderer");

class LogsViewComponent extends BaseLogsViewComponent {
    constructor(logger, gameEditor, state, io, JobEntity, JobLogEntity, storageFactory, MUF) {
        super(storageFactory);

        this._io = io;
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._JobEntity = JobEntity;
        this._JobLogEntity = JobLogEntity;
        this._modalUserFeedback = MUF;

        this._logId = state.logId;

        this._logFeed = undefined;

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    whenModelIsReady() {
        return this._gameEditor.whenDeviceIsReady().then(() => {
            this._device = this._gameEditor.getDevice();
            this._logFeed = this._JobLogEntity.startJobLogChangeFeed(this._gameEditor._activeOrgId, this._logId);
            this._registerLogFeedListeners();
            return this._logFeed.whenInitialized();
        });
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerLogFeedListeners() {
        this._logFeed.on("ElementsAdded", (this._onLogsAdded = this._onLogsAdded.bind(this)));
    }
    _unregisterLogFeedListeners() {
        if (this._logFeed) {
            this._logFeed.removeListener("ElementsAdded", this._onLogsAdded);
        }
    }
    _registerListeners() {}
    _unregisterListeners() {
        this._unregisterLogFeedListeners();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get device() {
        return this._device;
    }
    get logFile() {
        return this.getLogFile();
    }
    getLogFile() {
        return this._logFile;
    }
    get io() {
        return this._io;
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    retrieveJob() {
        return this._JobEntity.loadJob(this._device.tenantId, this._logId, {
            startObj: true,
            finishObj: true
        });
    }
    shutdown() {
        this._unregisterListeners();
        let rendererShutdownProm = this._renderer._shutdown();
        let superClassShutdownProm = super.shutdown();
        let logFeedShutdownProm = this._logFeed ? this._logFeed.shutdown() : Promise.resolve();
        this._logger = undefined;
        this._gameEditor = undefined;
        return Promise.all([rendererShutdownProm, superClassShutdownProm, logFeedShutdownProm]).then(() => {
            this._renderer = undefined;
            this._logFeed = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onLogsAdded(logs) {
        this.emit("LogsAdded", logs);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }
    get logger() {
        return this._logger;
    }
    get logId() {
        return this.getLogId();
    }
    getLogId() {
        return this._logId;
    }
    get logFeed() {
        return this.getLogFeed();
    }
    getLogFeed() {
        return this._logFeed;
    }
    getLogs() {
        return this._logFeed.getCacheAsArray();
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = LogsViewComponent;
LogsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.viewState",
    "$teve.io",
    "$teve.entities.Job",
    "$teve.entities.JobLog",
    "$teve.storageFactory",
    "$teve.ui.userFeedback"
];
LogsViewComponent.$displayDetails = {
    type: "View",
    name: "Logs",
    icon: "common.edit",
    shown: false
};
